import { createAsyncThunk } from '@reduxjs/toolkit';
import authResource from 'modules/auth/domain/resources/auth-resource';
import { AuthAvailableTournament } from 'modules/auth/domain/interfaces/auth-available-tournament';
import { IAuthGetAvailableTournamentsPayload } from 'modules/auth/domain/interfaces/auth-get-available-tournaments-payload';
import { RootState } from 'store/store';

const PREFIX = 'availableTournaments';

export const getAvailableTournaments = createAsyncThunk<
  { tournaments: AuthAvailableTournament[], userId: number },
  Omit<IAuthGetAvailableTournamentsPayload, 'namePart'>
>(`${PREFIX}/fetch`, async (payload, { rejectWithValue, getState }) => {
  try {
    const state = getState() as RootState;
    const userId = state.auth.user?.id;
    if (!userId) {
      throw new Error('User id not found');
    }

    const tournaments = await authResource.getAvailableTournaments({
      limit: payload.limit,
      offset: payload.offset,
    });
    return { tournaments, userId };
  } catch (error) {
    let message;
    if (error instanceof Error) message = error.message;
    else message = String(error);
    return rejectWithValue(message);
  }
});

export const getAvailableTournamentsByFilter = createAsyncThunk<
  AuthAvailableTournament[],
  Required<Pick<IAuthGetAvailableTournamentsPayload, 'namePart'>> & Pick<IAuthGetAvailableTournamentsPayload, 'limit' | 'offset'>
>(`${PREFIX}/fetchByFilter`, async (payload, { rejectWithValue }) => {
  try {
    return await authResource.getAvailableTournaments({
      limit: payload.limit,
      offset: payload.offset ?? 0,
      namePart: payload.namePart,
    });
  } catch (error) {
    let message;
    if (error instanceof Error) message = error.message;
    else message = String(error);
    return rejectWithValue(message);
  }
});
